const ITEMS = ["Fenster", "Haustüren", "Rollläden", "Sonnenschutz", "Insektenschutz", "Wintergärten", "Vordächer", "Schiebetüren", "Garagentore", "Zäune", "Pergolen"];

export const Marquee = () => (
  <div data-testid="marquee" className="bg-[#1e2226] border-y border-white/10 py-5 overflow-hidden select-none">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
          {ITEMS.map((item) => (
            <span key={`${half}-${item}`} className="flex items-center">
              <span className="font-display font-semibold uppercase tracking-[0.22em] text-2xl sm:text-3xl text-stroke-light px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="w-2.5 h-2.5 bg-[#e2001a] rotate-45 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
